import { faBolt } from '@fortawesome/pro-regular-svg-icons/faBolt';
import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import i18n from 'app/utils/i18n';
import { modalRoutes } from 'constants/routes';
import { UserPermission } from 'constants/userPermission';

export const automateReport = (context: ActionContext) =>
  createAction(
    {
      id: 'automate-report',
      label: () => i18n.t('reports.automation.automate'),
      icon: <Icon icon={faBolt} className="tw-text-orange-500" />,
      scopes: UserPermission.REPORT_CREATE,
      perform: ({ id }: { id: number }) => {
        context.modalHistory.push({
          hash: modalRoutes.AUTOMATE_REPORT,
          search: `?id=${id}`,
        });
      },
    },
    context,
  );
